import { useParams } from "react-router-dom";
import "./VoucherDetail.css";
import { useGetDetail } from "../../../../hooks/useGetDetail";
import Breadcrumb from "../../../common/Breadcrumb";
import { RotateCcw } from "lucide-react";
import { usePost } from "../../../../hooks";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Chip,
  Grid,
  Paper,
  Stack,
  Avatar,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { useState } from "react";
import {
  Person,
  LocalHospital,
  AssignmentReturn,
  Phone,
  Email,
  Cake,
  MedicalServices,
  Schedule,
  Payments,
  AccountBalanceWallet,
  MoneyOff,
  AttachMoney,
  Receipt,
} from "@mui/icons-material";

const VoucherDetail = () => {
  const { id } = useParams();

  const { data, loading } = useGetDetail("treatment-voucher", id);
  const [approveModal, setApproveModal] = useState({
    open: false,
    refund: null,
  });
  const { loading: postLoading, postData } = usePost(
    `ho/refund/treatment-voucher/${id}`,
  );
  const voucher = data ? data[0] : null;

  const handleApprove = () => {
    setApproveModal({ open: true, refund: null });
  };

  const confirmApprove = async () => {
    await postData({});
    setApproveModal({ open: false, refund: null });
  };
  const closeApproveModal = () => {
    setApproveModal({ open: false, refund: null });
  };

  return (
    // <div className="App">
    //   <div className="wrapper">
    //     <HeaderName />
    //     <SideBar />

    //     <div className="content-wrapper">

    //     </div>
    //   </div>
    // </div>
    <>
      <div className="ml-26 mt-3">
        <h1 className="text-lg"> Voucher Detail </h1>
        <Breadcrumb
          currentPage={"Voucher Detail"}
          links={[{ title: "Vouchers", path: "/voucher" }]}
        />
      </div>
      {loading ? (
        <>
          <div className="d-flex flex-column h-500 justify-content-center align-items-center py-4">
            <div
              className="spinner-border text-primary mb-2"
              role="status"
            ></div>
            <span>Loading data...</span>
          </div>
        </>
      ) : (
        <>
          <div className="page">
            {voucher?.Refund && (
              <Chip
                label="Refunded"
                size="small"
                sx={{
                  backgroundColor: "#4caf50",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "14px",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  margin: "10px 0",
                }}
              />
            )}
            {/* Top Summary */}
            <div className="summaryGrid">
              <div className="summaryCard">
                <div className="summaryTitle">Total Amount</div>
                <div className="summaryValue">
                  {" "}
                  {voucher ? voucher?.totalAmount?.toLocaleString() : 0}{" "}
                  MMK{" "}
                </div>
              </div>

              <div className="summaryCard">
                <div className="summaryTitle">Paid Amount</div>
                <div className="summaryValue summaryGreen">
                  {" "}
                  {voucher
                    ? voucher?.totalPaidAmount?.toLocaleString()
                    : 0}{" "}
                  MMK{" "}
                </div>
              </div>

              <div className="summaryCard">
                <div className="summaryTitle">Refunded</div>
                <div className="summaryValue">
                  {" "}
                  {voucher?.refundAmount?.toLocaleString()} MMK{" "}
                </div>
              </div>

              {/* <div className="summaryCard">
                <div className="summaryTitle">Refund Type</div>
                <div className="summaryValue">
                  {voucher ? voucher?.refundType : "N/A"}
                </div>
              </div> */}
            </div>

            {/* Info Section */}
            <Grid container spacing={3}>
              {/* Patient Information */}
              <Grid item xs={12} md={4}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    border: "1px solid #e4e7ec",
                    borderRadius: 2,
                    height: "100%",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2} mb={3}>
                    <Avatar sx={{ bgcolor: "#1976d2", width: 40, height: 40 }}>
                      <Person />
                    </Avatar>
                    <Typography variant="h6" fontWeight={600} color="#344054">
                      Patient Information
                    </Typography>
                  </Stack>

                  <Stack spacing={2.5}>
                    <Box>
                      <Typography
                        variant="caption"
                        color="#667085"
                        fontWeight={500}
                      >
                        Full Name
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {voucher?.relatedPatient?.name || "N/A"}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        variant="caption"
                        color="#667085"
                        fontWeight={500}
                      >
                        Patient ID
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {voucher?.relatedPatient?.patientID || "N/A"}
                      </Typography>
                    </Box>

                    <Stack direction="row" spacing={1}>
                      <Phone sx={{ fontSize: 16, color: "#667085" }} />
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Phone
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {voucher?.relatedPatient?.phone || "N/A"}
                        </Typography>
                      </Box>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                      <Email sx={{ fontSize: 16, color: "#667085" }} />
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Email
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {voucher?.relatedPatient?.email ||
                            voucher?.relatedPatient?.patientID ||
                            "N/A"}
                        </Typography>
                      </Box>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                      <Cake sx={{ fontSize: 16, color: "#667085" }} />
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Gender / Age
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {voucher?.relatedPatient?.gender || "N/A"},{" "}
                          {voucher?.relatedPatient?.age || "N/A"} yrs
                        </Typography>
                      </Box>
                    </Stack>
                  </Stack>
                </Paper>
              </Grid>

              {/* Doctor Information */}
              <Grid item xs={12} md={4}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    border: "1px solid #e4e7ec",
                    borderRadius: 2,
                    height: "100%",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2} mb={3}>
                    <Avatar sx={{ bgcolor: "#2e7d32", width: 40, height: 40 }}>
                      <LocalHospital />
                    </Avatar>
                    <Typography variant="h6" fontWeight={600} color="#344054">
                      Doctor Information
                    </Typography>
                  </Stack>

                  <Stack spacing={2.5}>
                    <Box>
                      <Typography
                        variant="caption"
                        color="#667085"
                        fontWeight={500}
                      >
                        Name
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {voucher?.relatedDoctor?.name || "N/A"}
                      </Typography>
                    </Box>

                    <Stack direction="row" spacing={1}>
                      <MedicalServices
                        sx={{ fontSize: 16, color: "#667085" }}
                      />
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Specialization
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {voucher?.relatedDoctor?.speciality || "N/A"}
                        </Typography>
                      </Box>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                      <Payments sx={{ fontSize: 16, color: "#667085" }} />
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Commission Amount
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {voucher?.relatedDoctor?.commissionAmount?.toLocaleString() ||
                            0}{" "}
                          MMK
                        </Typography>
                      </Box>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                      <Schedule sx={{ fontSize: 16, color: "#667085" }} />
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Schedule
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {voucher?.relatedDoctor?.schedule || "N/A"}
                        </Typography>
                      </Box>
                    </Stack>
                  </Stack>
                </Paper>
              </Grid>

              {/* Refund Information */}
              {voucher?.relatedRefundVoucher && (
                <Grid item xs={12} md={4}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      border: "1px solid #e4e7ec",
                      borderRadius: 2,
                      height: "100%",
                    }}
                  >
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={2}
                      mb={3}
                    >
                      <Avatar
                        sx={{ bgcolor: "#f44336", width: 40, height: 40 }}
                      >
                        <AssignmentReturn />
                      </Avatar>
                      <Typography variant="h6" fontWeight={600} color="#344054">
                        Refund Information
                      </Typography>
                    </Stack>

                    <Stack spacing={2.5}>
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Refund Type
                        </Typography>
                        <Typography variant="body2" fontWeight={500}>
                          {voucher?.relatedRefundVoucher?.refundType || "N/A"}
                        </Typography>
                      </Box>

                      {voucher?.relatedRefundVoucher?.refundType ===
                        "CashBack" && (
                        <Stack direction="row" spacing={1}>
                          <AttachMoney
                            sx={{ fontSize: 16, color: "#667085" }}
                          />
                          <Box>
                            <Typography
                              variant="caption"
                              color="#667085"
                              fontWeight={500}
                            >
                              Refund Amount
                            </Typography>
                            <Typography variant="body2" fontWeight={500}>
                              {voucher?.relatedRefundVoucher?.refundAmount?.toLocaleString() ||
                                0}{" "}
                              MMK
                            </Typography>
                          </Box>
                        </Stack>
                      )}

                      <Stack direction="row" spacing={1}>
                        <AccountBalanceWallet
                          sx={{ fontSize: 16, color: "#667085" }}
                        />
                        <Box>
                          <Typography
                            variant="caption"
                            color="#667085"
                            fontWeight={500}
                          >
                            Amount
                          </Typography>
                          <Typography variant="body2" fontWeight={500}>
                            {voucher?.relatedRefundVoucher?.refundableAmount?.toLocaleString() ||
                              0}{" "}
                            MMK
                          </Typography>
                        </Box>
                      </Stack>

                      <Stack direction="row" spacing={1}>
                        <MoneyOff sx={{ fontSize: 16, color: "#667085" }} />
                        <Box>
                          <Typography
                            variant="caption"
                            color="#667085"
                            fontWeight={500}
                          >
                            CashBack Amount
                          </Typography>
                          <Typography variant="body2" fontWeight={500}>
                            {voucher?.relatedRefundVoucher?.cashBackAmount?.toLocaleString() ||
                              0}{" "}
                            MMK
                          </Typography>
                        </Box>
                      </Stack>

                      <Divider sx={{ my: 1 }} />

                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Refund Paid Amount
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          color="#2e7d32"
                        >
                          {voucher?.relatedRefundVoucher?.refundPaidAmount?.toLocaleString() ||
                            0}{" "}
                          MMK
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Refund Discount
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          color="#f44336"
                        >
                          {voucher?.relatedRefundVoucher?.refundDiscount?.toLocaleString() ||
                            0}{" "}
                          MMK
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Refund Change
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          color="#1976d2"
                        >
                          {voucher?.relatedRefundVoucher?.refundChange?.toLocaleString() ||
                            0}{" "}
                          MMK
                        </Typography>
                      </Box>
                    </Stack>
                  </Paper>
                </Grid>
              )}

              {/* Voucher Information */}
              <Grid item xs={12} md={4}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    border: "1px solid #e4e7ec",
                    borderRadius: 2,
                    height: "100%",
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={2} mb={3}>
                    <Avatar sx={{ bgcolor: "#7c4dff", width: 40, height: 40 }}>
                      <Receipt />
                    </Avatar>
                    <Typography variant="h6" fontWeight={600} color="#344054">
                      Voucher Information
                    </Typography>
                  </Stack>

                  <Stack spacing={2.5}>
                    <Box>
                      <Typography
                        variant="caption"
                        color="#667085"
                        fontWeight={500}
                      >
                        Voucher Code
                      </Typography>
                      <Typography
                        variant="body2"
                        fontWeight={500}
                        sx={{ fontFamily: "monospace" }}
                      >
                        {voucher?.code || "N/A"}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        variant="caption"
                        color="#667085"
                        fontWeight={500}
                      >
                        Payment Method
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {voucher?.paymentMethod || "N/A"}
                      </Typography>
                    </Box>

                    <Stack direction="row" spacing={1}>
                      <AttachMoney sx={{ fontSize: 16, color: "#667085" }} />
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Total Amount
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          color="#1976d2"
                        >
                          {voucher?.totalAmount?.toLocaleString() || 0} MMK
                        </Typography>
                      </Box>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                      <Payments sx={{ fontSize: 16, color: "#667085" }} />
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Paid Amount
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          color="#2e7d32"
                        >
                          {voucher?.totalPaidAmount?.toLocaleString() || 0} MMK
                        </Typography>
                      </Box>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                      <AccountBalanceWallet
                        sx={{ fontSize: 16, color: "#667085" }}
                      />
                      <Box>
                        <Typography
                          variant="caption"
                          color="#667085"
                          fontWeight={500}
                        >
                          Balance Amount
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight={500}
                          color="#f44336"
                        >
                          {(
                            voucher?.totalAmount - voucher?.totalPaidAmount
                          )?.toLocaleString() || 0}{" "}
                          MMK
                        </Typography>
                      </Box>
                    </Stack>

                    <Divider sx={{ my: 1 }} />

                    <Box>
                      <Typography
                        variant="caption"
                        color="#667085"
                        fontWeight={500}
                      >
                        Created Date
                      </Typography>
                      <Typography variant="body2" fontWeight={500}>
                        {voucher?.createdAt
                          ? new Date(voucher.createdAt).toLocaleDateString()
                          : "N/A"}
                      </Typography>
                    </Box>
                  </Stack>
                </Paper>
              </Grid>
            </Grid>

            {/* Treatment Table */}
            {voucher?.multiTreatment?.length > 0 && (
              <div className="card">
                <div className="cardHeader">Treatment Items</div>

                <div className="table">
                  <div className="tableHeader">
                    <div className="col colTreatment">Treatment</div>
                    {/* <div className="col">Category</div> */}
                    <div className="col">Qty</div>
                    <div className="col">Unit Price</div>
                    <div className="col">Disc %</div>
                    <div className="col">Amount</div>
                  </div>

                  {voucher?.multiTreatment?.map((treatment) => (
                    <div className="tableRow">
                      <div className="col colTreatment">
                        {treatment?.item_id?.name || "N/A"}
                      </div>
                      <div className="col"> {treatment?.qty} </div>
                      <div className="col">
                        {" "}
                        {treatment?.price?.toLocaleString()} MMK{" "}
                      </div>
                      <div className="col">
                        {" "}
                        {treatment?.discountAmount?.toLocaleString() ?? 0}{" "}
                        MMK{" "}
                      </div>
                      <div className="col">
                        {" "}
                        {(
                          treatment?.qty * treatment?.price
                        ).toLocaleString()}{" "}
                        MMK{" "}
                      </div>
                    </div>
                  ))}

                  <div className="tableTotal">
                    <div className="totalLabel">Total</div>
                    <div className="totalValue">
                      {" "}
                      {voucher?.totalAmount.toLocaleString()} MMK{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Package Table */}
            {voucher?.relatedTreatmentPackageSelection?.length > 0 && (
              <div className="card">
                <div className="cardHeader">Package Items</div>

                <div className="table">
                  <div className="tableHeader">
                    <div className="col colTreatment">Package</div>
                    {/* <div className="col">Category</div> */}
                    <div className="col">Qty</div>
                    <div className="col">Unit Price</div>
                    <div className="col">Disc %</div>
                    <div className="col">Amount</div>
                  </div>

                  {voucher?.relatedTreatmentPackageSelection?.map((pack) => {
                    const selectedPackage =
                      pack?.multiTreatmentPackage?.find(
                        (item) =>
                          item?.item_id?.toString() ===
                          pack?.relatedTreatmentPackage?._id?.toString(),
                      ) ?? null;
                    return (
                      <div className="tableRow">
                        <div className="col colTreatment">
                          {pack?.relatedTreatmentPackage?.name || "N/A"}
                        </div>
                        <div className="col"> {selectedPackage?.qty} </div>
                        <div className="col">
                          {selectedPackage?.price.toLocaleString()} MMK
                        </div>
                        <div className="col">
                          {selectedPackage?.discountAmount?.toLocaleString() ??
                            0}{" "}
                          MMK
                        </div>
                        <div className="col">
                          {(
                            selectedPackage?.qty * selectedPackage?.price
                          ).toLocaleString()}
                          MMK
                        </div>
                      </div>
                    );
                  })}

                  <div className="tableTotal">
                    <div className="totalLabel">Total</div>
                    <div className="totalValue">
                      {voucher?.totalAmount.toLocaleString()} MMK
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Dental Treatment Table */}
            {voucher?.multiDentalTreatment?.length > 0 && (
              <div className="card">
                <div className="cardHeader">Dental Treatment Items</div>

                <div className="table">
                  <div className="tableHeader">
                    <div className="col colTreatment">Treatment</div>
                    {/* <div className="col">Category</div> */}
                    <div className="col">Qty</div>
                    <div className="col">Unit Price</div>
                    <div className="col">Disc %</div>
                    <div className="col">Amount</div>
                  </div>

                  {voucher?.multiDentalTreatment?.map((treatment) => (
                    <div className="tableRow">
                      <div className="col colTreatment">
                        {treatment?.item_id?.name || "N/A"}
                      </div>
                      <div className="col"> {treatment?.qty} </div>
                      <div className="col">
                        {treatment?.price?.toLocaleString()} MMK
                      </div>
                      <div className="col">
                        {treatment?.discountAmount?.toLocaleString() ?? 0}
                        MMK
                      </div>
                      <div className="col">
                        {(treatment?.qty * treatment?.price).toLocaleString()}
                        MMK
                      </div>
                    </div>
                  ))}

                  <div className="tableTotal">
                    <div className="totalLabel">Total</div>
                    <div className="totalValue">
                      {" "}
                      {voucher?.totalAmount.toLocaleString()} MMK{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {!voucher?.Refund && (
              <div className="d-flex g-3 align-items-center">
                <button className="btn-cancel">Cancel</button>
                <div style={{ width: "10px" }}></div>
                <button className="btn-approve" onClick={handleApprove}>
                  <RotateCcw className="btn-icon" />
                  Approve Refund
                </button>
              </div>
            )}

            {/* Refund Treatment Table */}
            {voucher?.relatedRefundVoucher?.multiTreatment?.length > 0 && (
              <div className="card">
                <div className="cardHeader">Refund Treatment Items</div>

                <div className="table">
                  <div className="tableHeader">
                    <div className="col colTreatment">Treatment</div>
                    {/* <div className="col">Category</div> */}
                    <div className="col">Qty</div>
                    <div className="col">Unit Price</div>
                    <div className="col">Disc %</div>
                    <div className="col">Amount</div>
                  </div>

                  {voucher?.relatedRefundVoucher?.multiTreatment?.map(
                    (treatment) => (
                      <div className="tableRow">
                        <div className="col colTreatment">
                          {treatment?.item_id?.name || "N/A"}
                        </div>
                        <div className="col"> {treatment?.qty} </div>
                        <div className="col">
                          {" "}
                          {treatment?.price?.toLocaleString()} MMK{" "}
                        </div>
                        <div className="col">
                          {" "}
                          {treatment?.discountAmount?.toLocaleString() ??
                            0}{" "}
                          MMK{" "}
                        </div>
                        <div className="col">
                          {" "}
                          {(
                            treatment?.qty * treatment?.price
                          ).toLocaleString()}{" "}
                          MMK{" "}
                        </div>
                      </div>
                    ),
                  )}

                  <div className="tableTotal">
                    <div className="totalLabel">Total</div>
                    <div className="totalValue">
                      {" "}
                      {voucher?.relatedRefundVoucher?.totalAmount.toLocaleString()}{" "}
                      MMK{" "}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <Dialog
              open={approveModal.open}
              onClose={closeApproveModal}
              aria-labelledby="approve-dialog-title"
              aria-describedby="approve-dialog-description"
            >
              <DialogTitle id="approve-dialog-title">
                Confirm Refund Approval
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="approve-dialog-description">
                  Are you sure you want to approve this refund request?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <>
                  <Button
                    onClick={closeApproveModal}
                    color="secondary"
                    disabled={postLoading}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={confirmApprove}
                    variant="contained"
                    sx={{
                      backgroundColor: "#4caf50",
                      "&:hover": { backgroundColor: "#45a049" },
                    }}
                    autoFocus
                    disabled={postLoading}
                  >
                    {postLoading ? (
                      <CircularProgress size={20} sx={{ color: "white" }} />
                    ) : (
                      "Approve"
                    )}
                  </Button>
                </>
              </DialogActions>
            </Dialog>
          </div>
        </>
      )}
    </>
  );
};
export default VoucherDetail;
